import { Transaction } from "../types";

export const sampleTransactions: Transaction[] = [
  {
    id: "1",
    amount: 5000,
    description: "Monthly Salary",
    category: "Salary",
    type: "income",
    date: new Date().toISOString().split("T")[0],
    paymentMethod: "Bank Transfer",
    tags: ["monthly", "salary"],
  },
  {
    id: "2",
    amount: 150.5,
    description: "Grocery Shopping",
    category: "Food & Dining",
    type: "expense",
    date: new Date().toISOString().split("T")[0],
    paymentMethod: "Credit Card",
    tags: ["grocery", "weekly"],
  },
  {
    id: "3",
    amount: 15.99,
    description: "Netflix Subscription",
    category: "Entertainment",
    type: "expense",
    date: new Date().toISOString().split("T")[0],
    paymentMethod: "Credit Card",
    tags: ["subscription"],
  },
  {
    id: "4",
    amount: 800,
    description: "Freelance Project",
    category: "Freelance",
    type: "income",
    date: new Date().toISOString().split("T")[0],
    paymentMethod: "PayPal",
    tags: ["freelance", "project"],
  },
  {
    id: "5",
    amount: 45.75,
    description: "Gas Refill",
    category: "Transportation",
    type: "expense",
    date: new Date().toISOString().split("T")[0],
    paymentMethod: "Debit Card",
    tags: ["car", "fuel"],
  },
];

export const loadSampleData = () => {
  if (window.confirm("Load sample data? This will add example transactions.")) {
    const saved = localStorage.getItem("stanza-transactions");
    const existingTransactions = saved ? JSON.parse(saved) : [];
    const combinedTransactions = [
      ...sampleTransactions,
      ...existingTransactions,
    ];
    localStorage.setItem(
      "stanza-transactions",
      JSON.stringify(combinedTransactions)
    );
    window.location.reload();
  }
};

export const clearAllData = () => {
  if (
    window.confirm(
      "Are you sure you want to clear all data? This cannot be undone."
    )
  ) {
    localStorage.removeItem("stanza-transactions");
    window.location.reload();
  }
};
